import React, { memo, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";

function AdminSidebar({ currentPage }) {
    const navigate = useNavigate();

    const handleLogout = () => {
        // localStorage'dan token ve user bilgilerini temizle
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");

        // Navbar'ın güncellenmesi için custom event dispatch et
        window.dispatchEvent(new Event("loginStatusChanged"));

        // Ana sayfaya yönlendir
        navigate("/");
    };

    const menuItems = useMemo(() => [
        {
            key: "dashboard",
            to: "/admin",
            icon: (
                <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 6h16M4 12h16M4 18h7"
                    />
                </svg>
            ),
            label: "Dashboard",
        },
        {
            key: "customers",
            to: "/admin/customers",
            icon: (
                <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                    />
                </svg>
            ),
            label: "Müşteriler",
        },
        {
            key: "yachts",
            to: "/admin/yachts",
            icon: (
                <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                </svg>
            ),
            label: "Yatlar",
        },
        {
            key: "reservations",
            to: "/admin/reservations",
            icon: (
                <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                </svg>
            ),
            label: "Yat Müsaitlikleri",
        },
        {
            key: "reserved-yachts",
            to: "/admin/reserved-yachts",
            icon: (
                <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                    />
                </svg>
            ),
            label: "Rezerve Yatlar",
        },
        {
            key: "reports",
            to: "#",
            icon: (
                <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    />
                </svg>
            ),
            label: "Raporlar",
        },
        {
            key: "settings",
            to: "#",
            icon: (
                <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                </svg>
            ),
            label: "Ayarlar",
        },
    ], []); // Empty dependency array since menu items are static

    return (
        <div
            className="w-64 h-screen fixed left-0 top-0 bg-gray-900/50 backdrop-blur-sm p-6 flex flex-col justify-between z-10"
            style={{
                willChange: 'transform',
                transform: 'translateZ(0)',
                backfaceVisibility: 'hidden',
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale'
            }}
        >
            <div className="border-none outline-none">
                <div className="mb-10">
                    <Link
                        to="/"
                        className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent inline-flex items-center gap-2"
                    >
                        Cyprus Yacht Club
                        <span className="text-2xl">⛵</span>
                    </Link>
                </div>

                <nav className="space-y-2 border-none">
                    {menuItems.map((item) => (
                        <Link
                            key={item.key}
                            to={item.to}
                            className={`group relative flex items-center gap-3 px-4 py-3 rounded-2xl transition-all duration-500 ease-in-out transform ${
                                currentPage === item.key
                                    ? "bg-gradient-to-r from-blue-500/20 to-blue-600/20 text-blue-300 shadow-lg shadow-blue-500/10 scale-[1.02]"
                                    : "text-white/70 hover:text-white hover:bg-white/10 hover:shadow-lg hover:shadow-black/20 hover:scale-[1.02]"
                            }`}
                            style={{
                                transformOrigin: 'center',
                                backfaceVisibility: 'hidden',
                                WebkitFontSmoothing: 'antialiased'
                            }}
                        >
                            <div className={`transition-all duration-500 ease-in-out transform ${
                                currentPage === item.key
                                    ? "text-blue-400 scale-110"
                                    : "text-white/60 group-hover:text-white group-hover:scale-105"
                            }`}
                            style={{
                                transformOrigin: 'center',
                                backfaceVisibility: 'hidden'
                            }}>
                                {item.icon}
                            </div>
                            <span className="font-medium transition-all duration-500 ease-in-out">
                                {item.label}
                            </span>
                            {currentPage === item.key && (
                                <div
                                    className="absolute right-3 w-2 h-2 bg-blue-400 rounded-full shadow-lg shadow-blue-400/50 animate-pulse"
                                    style={{
                                        animation: 'fadeInScale 0.3s ease-out'
                                    }}
                                ></div>
                            )}
                        </Link>
                    ))}
                </nav>
            </div>

            <div className="mb-2">
                <button
                    onClick={handleLogout}
                    className="group w-full flex items-center justify-center gap-3 px-4 py-3 text-white/70 hover:text-white hover:bg-red-500/20 rounded-2xl transition-all duration-300 hover:shadow-lg hover:shadow-red-500/10 hover:scale-[1.02] border border-white/10 hover:border-red-500/30"
                >
                    <svg
                        className="w-5 h-5 transition-all duration-300 group-hover:scale-105 group-hover:text-red-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                        />
                    </svg>
                    <span className="font-medium">Çıkış Yap</span>
                </button>
            </div>
        </div>
    );
}

export default memo(AdminSidebar);
